import { render, staticRenderFns } from "./MintConfig.vue?vue&type=template&id=21ecd5e0&"
import script from "./MintConfig.vue?vue&type=script&lang=js&"
export * from "./MintConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports